import dayjs from "dayjs";
import {jsonArrayMember, jsonMember, jsonObject, TypedJSON} from "typedjson";

@jsonObject()
export class StateChange {
    @jsonMember(String)
    new: string;

    @jsonMember(String)
    old: string;
}

const numericOptions = {
    deserializer: (value: unknown) => {
        return (typeof value === 'string') ? parseFloat(value) : Number(value)
    }
};

/**
 * Base class for sample reports, containing common fields like temperature, humidity.
 * These fields are sometimes sent in multiple clubbed reports as well.
 */
@jsonObject()
export class BaseSampleReport {
    @jsonMember(Number, numericOptions)
    temperature: number;

    @jsonMember(Number, numericOptions)
    humidity: number;

    @jsonMember(Number, numericOptions)
    light: number;

    @jsonMember(Boolean)
    is_light_detected: boolean;

    @jsonMember(String)
    moving: string;

    @jsonMember(String)
    acc_x: string;

    @jsonMember(String)
    acc_y: string;

    @jsonMember(String)
    acc_z: string;
}

@jsonObject()
export class EventUpdateData extends BaseSampleReport {
    @jsonMember(Number, numericOptions)
    eventCode: number;

    @jsonMember(String)
    protocol: string;

    @jsonMember(String)
    device_model: string;

    @jsonMember(String)
    imei: string;

    @jsonMember(String)
    reportId: string;

    @jsonMember(String)
    reportType: string;

    @jsonMember(String)
    radio: string;

    @jsonMember(Number, numericOptions)
    mcc: number;

    @jsonMember(Number, numericOptions)
    mnc: number;

    @jsonMember(Number, numericOptions)
    lac: number;

    @jsonMember(Number, numericOptions)
    cellID: number;

    @jsonMember(String)
    lac_hex: string;

    @jsonMember(String)
    cellID_hex: string;

    @jsonMember(String)
    address: string;

    @jsonMember(String)
    location: string;

    @jsonArrayMember(BaseSampleReport)
    sampledReports: BaseSampleReport[];

    @jsonMember(String)
    accessoryVoltage: string;

    @jsonMember(Number, numericOptions)
    battery_level: number;

    @jsonMember(Boolean)
    in_flight_mode: boolean;

    @jsonMember(() => dayjs.Dayjs, {
        deserializer: (value: any) => {
            return value ? dayjs(value, 'YYYY-MM-DDTHH:mm:ss', true) : null;
        }
    })
    report_time: dayjs.Dayjs;
}


@jsonObject()
export class EventUpdate {
    @jsonMember(String)
    sourceId: string;

    @jsonMember(String)
    sourceName: string;

    @jsonMember(String)
    date: string;
    @jsonMember(String)
    message: string;
    @jsonMember(String)
    user: string;

    @jsonMember(String)
    state: string;

    @jsonMember(() => dayjs.Dayjs, {
        deserializer: (value: any) => {
            return value && dayjs(value);
        }
    })
    creationDate: dayjs.Dayjs;

    @jsonMember(EventUpdateData)
    data: EventUpdateData;
}


export const EventUpdateSerializer = new TypedJSON(EventUpdate);
